import { Action, createReducer, on } from '@ngrx/store';
import {
  checkIfUserBlockedRequest,
  checkIfUserBlockedFailure,
  checkIfUserBlockedSuccess,
  clearStatusRequest
} from '../actions/block.actions';
import { IsUserBlockedRequest, IsUserBlockedResponse } from '../models/block.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const checkUserBlockedFeatureKey = 'checkUserBlocked';

export interface CheckUserBlockedState {
  checkBlockUserRequest: string;
  checkBlockUserSuccess: IsUserBlockedResponse;
  checkBlockUserFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: CheckUserBlockedState = {
  checkBlockUserRequest: undefined,
  checkBlockUserSuccess: undefined,
  checkBlockUserFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(checkIfUserBlockedRequest, (state, action) => ({
    ...state,
    checkBlockUserRequest: action.request
  })),
  on(checkIfUserBlockedSuccess, (state, action) => ({
    ...state,
    checkBlockUserSuccess: action.response,
    loaded: true
  })),
  on(checkIfUserBlockedFailure, (state, action) => ({
    ...state,
    checkBlockUserFailure: action.error
  })),
  on(clearStatusRequest, (state, action) => ({
    ...state,
    checkBlockUserSuccess: undefined,
    loaded: false
  }))
);

export const checkBlockUserRequest = (state: CheckUserBlockedState) => state.checkBlockUserRequest;
export const checkBlockUserResponse = (state: CheckUserBlockedState) => state.checkBlockUserSuccess;
export const checkBlockUserFailure = (state: CheckUserBlockedState) => state.checkBlockUserFailure;
export const getUserStatusIsloaded = (state: CheckUserBlockedState) => state.loaded;
